<template>
    <div class="sustainable-component pot-position-salary">
        <!--<div class="bg-success mb-3 p-3 rounded">vue component pot-position-salary</div>-->
        <div class="container-fluid p-0 pt-3">
            <div class="row mt-3" v-if="calculationType == '0'">

                <div class="col-12 col-md-7">
                    <CommonLabelContainer title="Konstruktion">
                        <div class="container-fluid p-0">
                            <div class="col-12">
                                Nuvarande värde per block: <span v-decimal-text.max2="blockSalary"></span> kr
                            </div>
                            <div class="col-12 mt-3">
                                <v-text-field :decimal-sv="true" v-bind:disabled="disabled" bg-color="white" label="Nytt värde i kr" v-model="potBlockSalary" variant="outlined"></v-text-field>
                            </div>
                            <div class="col-12">
                                <v-btn v-bind:disabled="disabled" size="default" color="primary" class="btn-primary" @click="setBlockPartSalary">
                                    Spara
                                </v-btn>
                            </div>
                        </div>
                    </CommonLabelContainer>
                </div>
                <div class="col-12 col-md-5 mt-3 mt-md-0">
                    <div style="border: 1px solid #777777; background-color: White; padding: 10px;">
                        <p>Löneökning kr: <strong><span v-decimal-text.max2="BLDSalaryIncrease"></span></strong></p>
                        <p>Löneökning %: <strong><span v-decimal-text.max2="BLDSalaryIncreaseProcentage"></span></strong></p>
                    </div>
                </div>
            </div>
            <div class="row mt-3" v-if="calculationType == '1'">

                <div class="col-12 col-md-7 mr-3 mb-3">

                    <div class="card px-3 py-5 rounded common-label-container">
                        <div class="common-label-tab-container rounded">
                            <div class="px-3 pt-1 rounded tab-contained" style="background-color: white">Konstruktion</div>
                        </div>
                        <div>
                            <!-- content -->
                            <div class="container-fluid p-0">
                                <div class="row">
                                    <div class="col-12">
                                        För att spara data klickar du antingen på ”Spara” som finns på respektive rad eller knappen
                                        "Skapa värden i lönesystemet" som finns under tabellen.
                                        <div class="table-scrollable-container">
                                            <table class="table table-light table-hover table-striped">
                                                <thead class="thead-light">
                                                    <tr>
                                                        <th class="col-2">Befattning</th>
                                                        <th class="col-2">Blocknr.</th>
                                                        <th class="col-2">Blocknamn</th>
                                                        <th class="col-2">Värde kr</th>
                                                        <th class="col-2">Nytt Värde kr</th>
                                                        <th class="col-2"></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(positionBlock, index) in jobPositionsWithBlocks" :key="index">
                                                        <td>{{positionBlock.JobPositionName}}</td>
                                                        <td>{{positionBlock.BlockNumber}}</td>
                                                        <td>{{positionBlock.Name}}</td>
                                                        <td><span v-decimal-text.max2="positionBlock.Salary"></span></td>
                                                        <td>
                                                            <v-text-field :decimal-sv="true" v-bind:disabled="disabled" bg-color="white" v-model="positionBlock.PotSalary" hide-details="true" density="compact" variant="outlined"></v-text-field>
                                                        </td>
                                                        <td>
                                                            <div class="pull-right" style="" v-if="disabled == false">
                                                                <div class="dropdown text-right pr-2">
                                                                    <a href="#" class="drop" data-bs-toggle="dropdown" aria-expanded="false">
                                                                        ...
                                                                    </a>
                                                                    <div class="dropdown-menu dropdown-menu-right">
                                                                        <a href="javascript:void(0)" class="dropdown-item" @click="savePositionBlockSalary(positionBlock)">Spara</a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>

                                        </div>

                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <v-btn v-bind:disabled="disabled" size="default" color="primary" class="btn-primary" @click="setAllSalaries">
                                            Spara
                                        </v-btn>
                                    </div>
                                </div>
                            </div>
                            <!-- end content -->
                        </div>
                    </div>

                </div>
                <div class="col-12 col-md-5 mt-3 mt-md-0">
                    <div style="border: 1px solid #777777; background-color: White; padding: 10px;">
                        <p>Löneökning kr: <strong><span v-decimal-text.max2="BLDSalaryIncrease"></span></strong></p>
                        <p>Löneökning %: <strong><span v-decimal-text.max2="BLDSalaryIncreaseProcentage"></span></strong></p>
                    </div>
                </div>
            </div>
            <div class="row mt-3" v-if="calculationType == '2'">
                <div class="col-12 col-md-7">
                    <div class="card px-3 py-5 rounded common-label-container">
                        <div class="common-label-tab-container rounded">
                            <div class="px-3 pt-1 rounded tab-contained" style="background-color: white">Konstruktion</div>
                        </div>
                        <div>
                            <!-- content -->
                            <div class="container-fluid p-0">
                                <div class="row">
                                    <div class="col-12">
                                        För att spara data klickar du antingen på ”Spara” som finns på respektive rad eller knappen
                                        "Skapa värden i lönesystemet" som finns under tabellen.

                                        <table class="table table-light table-hover table-striped">
                                            <thead class="thead-light">
                                                <tr>
                                                    <th class="col-3">Poäng fr.o.m.</th>
                                                    <th class="col-2">Poäng t.o.m.</th>
                                                    <th class="col-3">Värde kr</th>
                                                    <th class="col-3">Nytt Värde kr</th>
                                                    <th class="col-1"></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(interval, index) in intervals" :key="index">
                                                    <td>{{interval.From}}</td>
                                                    <td>{{interval.To}}</td>
                                                    <td><span v-decimal-text.max2="interval.Salary"></span></td>
                                                    <td><span v-decimal-text.max2="interval.PotSalary"></span></td>
                                                    <td>
                                                        <div class="pull-right" style="" v-if="disabled == false">
                                                            <div class="dropdown text-right pr-2">
                                                                <a href="#" class="drop" data-bs-toggle="dropdown" aria-expanded="false">
                                                                    ...
                                                                </a>
                                                                <div class="dropdown-menu dropdown-menu-right">
                                                                    <a href="javascript:void(0)" class="dropdown-item" @click="updateInterval(interval)">Uppdatera</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <!-- end content -->
                        </div>
                    </div>



                </div>
                <div class="col-12 col-md-5 mt-3 mt-md-0">
                    <div style="border: 1px solid #777777; background-color: White; padding: 10px;">
                        <p>Löneökning kr: <strong><span v-decimal-text.max2="BLDSalaryIncrease"></span></strong></p>
                        <p>Löneökning %: <strong><span v-decimal-text.max2="BLDSalaryIncreaseProcentage"></span></strong></p>
                    </div>
                </div>

            </div>
            <div class="row mt-3" v-if="calculationType == '3'">
                <div class="col-12 col-md-7">
                    <CommonLabelContainer title="Konstruktion">
                        <div class="container-fluid p-0">
                            <div class="row">
                                <div class="col-12">
                                    Nuvarande värde per poäng: <span v-decimal-text.max2="blockSalaryPerPoint"></span> kr
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-12">
                                    <v-text-field :decimal-sv="true" v-bind:disabled="disabled" bg-color="white" label="Nytt värde per poäng" v-model="potSalaryPerPoints" variant="outlined"></v-text-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <v-btn v-bind:disabled="disabled" size="default" color="primary" class="btn-primary" @click="setBlockPartSalary">
                                        Spara
                                    </v-btn>
                                </div>
                            </div>
                        </div>
                    </CommonLabelContainer>
                </div>
                <div class="col-12 col-md-5 mt-3 mt-md-0">
                    <div style="border: 1px solid #777777; background-color: White; padding: 10px;">
                        <p>Löneökning kr: <strong><span v-decimal-text.max2="BLDSalaryIncrease"></span></strong></p>
                        <p>Löneökning %: <strong><span v-decimal-text.max2="BLDSalaryIncreaseProcentage"></span></strong></p>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12 col-md-7 mr-3 mt-3">
                    <v-select bg-color="white" variant="outlined" v-bind:label="$t('general.workorganisation_general_position')" :items="positions" v-model="selectedPosition" item-title="Name" item-value="JobPositionId"></v-select>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-12"><b>Utfall</b></div>
            </div>
            <div class="row">
                <div class="col-12 col-md-7 mr-3">
                    <table class="table table-light table-hover table-striped">
                        <thead class="thead-light">
                            <tr>
                                <th class="col-6">Blocknamn</th>
                                <th class="col-2" v-if="calculationType == '2' || calculationType == '3'">Poäng</th>
                                <th class="col-2">Värde kr</th>
                                <th class="col-2">Nytt värde kr</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, index) in jobPositionBlocks" :key="index">
                                <td>{{row.Name}}</td>
                                <td v-if="calculationType == '2' || calculationType == '3'">{{row.Points}}</td>
                                <td><span v-decimal-text.max2="row.Salary"></span></td>
                                <td><span v-decimal-text.max2="row.PotSalary"></span></td>
                            </tr>
                        </tbody>

                    </table>
                    <div class="mt-3">Summa värde: {{getSumSalary(jobPositionBlocks)}}</div>
                </div>
            </div>
        </div>

        <WagePotSalaryInterval v-bind:disabled="disabled" :model="model" ref="updatePotSalaryInterval" @updated="updateAfterChange"></WagePotSalaryInterval>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>

<script>

    import WageService from "../../Services/WageService";
    import WorkOrganisationService from "../../Services/WorkOrganisationService";
    import CommonLabelContainer from "../../common/common-label-container";
    import { getCurrentInstance } from 'vue'
    import WagePotSalaryInterval from '../wagesetting/update/update-pot-salary-interval.vue'
    import CommonSpinner from '../../common/common-spinner.vue'
    import { ref } from 'vue'

    const updatePotSalaryInterval = ref(null);

    export default {
        emits: ['updated'],
        name: 'pot-position-salary',
        components: {
            CommonLabelContainer,
            WagePotSalaryInterval,
            CommonSpinner
        },
        props: {
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        methods: {
            getId() {
                return getCurrentInstance().uid;
            },
            getAsSwedishNumberString(number) {
                return number.toString().replace(".", ",");
            },
            updateInterval(item) {
                this.loading++;
                this.updatePotSalaryInterval.open(item);
                this.loading--;
            },
            async getPositionsWithPoints() {
                this.loading++;
                try {
                    this.positions = await WageService.getPositionsWithPoints();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async savePositionBlockSalary(positionBlock) {
                this.loading++;
                try {
                    await WageService.updatePositionBlockPotSalary(positionBlock);
                    this.updateAfterChange()
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            setBlockPartSalary() {
                this.loading++;
                try {
                    this.updateAfterChange()
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async setAllSalaries() {
                this.loading++;
                try {
                    await WageService.updatePositionBlockPotSalaries(this.jobPositionsWithBlocks);
                    this.updateAfterChange();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async updateAfterChange() {
                this.loading++;
                try {
                    await WageService.updateBlockPotWagepart(false, this.calculationType, this.potBlockSalary, this.potSalaryPerPoints);
                    this.refreshViews();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async refreshViews() {
                this.loading++;
                try {
                    if (this.calculationType == "1") {
                        this.getJobPositionsWithBlocks();
                    }
                    else if (this.calculationType == "2") {
                        this.loadIntervals();
                    }
                    if (this.selectedPosition != null) {
                        this.getJobPositionBlocksPointSumAll(this.selectedPosition);
                    }
                    this.loadPotDistribution();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async loadIntervals() {
                this.loading++;
                try {
                    this.intervals = await WageService.getSalaryInterval(1);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async getJobPositionBlocksPointSumAll(jobPositionId) {
                this.loading++;
                try {
                    this.jobPositionBlocks = await WorkOrganisationService.getJobPositionBlocksPointSumAll(jobPositionId);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async getSalaryPart() {
                this.loading++;
                try {
                    var salaryPart = await WageService.getWagePartBlock();
                    this.blockSalaryPerPoint = salaryPart.BlockSalaryPerPoint;
                    this.blockSalary = salaryPart.BlockSalary;
                    this.potSalaryPerPoints = salaryPart.PotSalaryPerPoints;
                    this.potBlockSalary = salaryPart.PotBlockSalary;
                    this.calculationType = salaryPart.CalculationType.toString();
                    this.refreshViews()
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async getJobPositionsWithBlocks() {
                this.loading++;
                try {
                    var tmp = await WorkOrganisationService.getJobPositionsWithBlocks();
                    var latestPositionName = null;
                    for (var i = 0; i < tmp.length; i++) {
                        if (tmp[i].JobPositionName != latestPositionName)
                            latestPositionName = tmp[i].JobPositionName;
                        else
                            tmp[i].JobPositionName = null;
                    }
                    this.jobPositionsWithBlocks = tmp;
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async createInterval() {
                this.loading++;
                try {
                    await WageService.addBlockSalaryInterval(this.startPoint, this.endPoint, this.salary);
                    this.updateAfterChange()
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },

            async updateSalariesWithPoint() {
                this.loading++;
                try {
                    this.updateAfterChange()
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            getSumSalary(jobPositionBlocks) {
                var sum = 0;
                for (var i = 0; i < jobPositionBlocks.length; i++) {
                    sum += jobPositionBlocks[i].PotSalary;
                }
                return sum;
            },
            async loadPotDistribution() {
                this.loading++;
                try {
                    var result = await WageService.getPotDistribution()
                    this.BLDSalaryIncrease = this.getAsSwedishNumberString(result.BLDSalaryIncrease);
                    this.BLDSalaryIncreaseProcentage = this.getAsSwedishNumberString(result.BLDSalaryIncreaseProcentage);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },
        data() {
            return {
                jobPositionsWithBlocks: [],
                jobPositionBlocks: [],
                selectedPosition: null,
                positionSalariesWithPoints: [],
                intervals: [],
                startPoint: null,
                endPoint: null,
                blockSalary: null,
                blockSalaryPerPoint: null,
                potSalaryPerPoints:null,
                potBlockSalary:null,
                calculationType: "0",
                positions: [],
                BLDSalaryIncrease: "0",
                BLDSalaryIncreaseProcentage: "0",
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {
            selectedPosition: function (newVal) {
                this.getJobPositionBlocksPointSumAll(newVal)
            },
        },
        mounted() {
            this.getSalaryPart();
            this.loadIntervals();
            this.loadPotDistribution();
            this.getPositionsWithPoints();
            this.getJobPositionsWithBlocks()
        },

        // eslint-disable-next-line
        setup(props, { emit }) {
            return { updatePotSalaryInterval }
        }

    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    

</style>
